import { EventContentArg } from '@fullcalendar/core';
import { makeStyles } from 'tss-react/mui';
import { CalendarEvent } from '../../../../sic-lib/types/CalendarEvent';

const useStyles = makeStyles()(theme => ({
    root: {
        overflow: 'hidden',
    },
}));

interface Props {
    fcCalendarEvent: EventContentArg;
    calendarEvent: CalendarEvent | undefined;
}

export default function MonthCalendarEvent({ fcCalendarEvent, calendarEvent }: Props) {
    const { classes } = useStyles();

    const contactName =
        calendarEvent && calendarEvent.contactName ? 'with ' + calendarEvent.contactName : '';

    return (
        <div className={classes.root}>
            {fcCalendarEvent.timeText} {contactName}
        </div>
    );
}
